import React, { FC } from 'react';
import { Modal, Tabs, TabsProps } from 'antd';
import { AdminsDataPrepared } from 'shared/types/admins.types';
import UpdateAdminForm from './update-admin-form/UpdateAdminForm';
import UpdateAdminPasswordForm from './update-password/UpdatePassword';

type TAddEmployeeModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  admin: AdminsDataPrepared | null;
};

export const UpdateAdminModal: FC<TAddEmployeeModalProps> = ({ isModalOpen, setIsModalOpen, admin }) => {
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Редактирование',
      children: <UpdateAdminForm admin={admin} setIsModalOpen={setIsModalOpen} />,
    },
    {
      key: '2',
      label: 'Изменение пароля',
      children: <UpdateAdminPasswordForm admin={admin} setIsModalOpen={setIsModalOpen} />,
    },
  ];

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Редактирование администратора"
      footer={false}
      onCancel={handleCancel}
      open={isModalOpen}
      bodyStyle={{ padding: '40px' }}
      width={900}
      destroyOnClose
    >
      <Tabs defaultActiveKey="1" items={items} />
    </Modal>
  );
};
